import { Controller } from "@hotwired/stimulus"

// salva() di ReimpostaPassword.js: setErrore("") e poi i controlli fatti nel browser, con gli stessi testi; se uno
// fallisce l'errore compare nel riquadro e il form non parte (Turbo ignora l'invio con preventDefault).
export default class extends Controller {
  static targets = ["password", "conferma"]

  salva(event) {
    this.mostra("")
    let errore = ""
    if (this.passwordTarget.value.length < 8) errore = "La password deve avere almeno 8 caratteri."
    else if (this.passwordTarget.value !== this.confermaTarget.value) errore = "Le due password non coincidono."
    if (!errore) return
    event.preventDefault()
    this.mostra(errore)
  }

  mostra(testo) {
    const attuale = this.element.querySelector("#reimposta-errore")
    if (!attuale) return
    const nuovo = document.createElement("div")
    nuovo.id = attuale.id
    if (testo) {
      nuovo.className = "text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded-md px-3 py-2"
      nuovo.textContent = testo
    } else {
      nuovo.hidden = true
    }
    attuale.replaceWith(nuovo)
  }
}
